<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as PROFESSIONAL_REG_TYPES } from './store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'ProfessionalRegisterCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: PROFESSIONAL_REG_TYPES.GENERIC.miscellaneous.professionalregister.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...PROFESSIONAL_REG_TYPES.GENERIC.miscellaneous.professionalregister.LIST.ACTIONS
    })
  }
}
</script>
